import { DialogBase } from '@ipfabric/ui-components/DialogBase/DialogBase';
import {
  Button,
  type ButtonAccent,
  type ButtonVariant,
} from 'components/Button/Button';
import type { FC, ReactNode } from 'react';

export interface DialogProps {
  capToWindowHeight?: boolean;
  children?: ReactNode;
  closable?: boolean;
  headerMsg: ReactNode;
  subHeaderMsg?: ReactNode;
  primaryBtnMsg: ReactNode;
  secondaryBtnMsg?: ReactNode;
  onClose: () => void;
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
  primaryBtnAccent?: ButtonAccent;
  primaryBtnDataTestId?: string;
  primaryBtnLoading?: boolean;
  primaryBtnVariant?: ButtonVariant;
  primaryDisabled?: boolean;
  secondaryBtnAccent?: ButtonAccent;
  secondaryBtnDataTestId?: string;
  secondaryBtnVariant?: ButtonVariant;
  secondaryDisabled?: boolean;
}

export const Dialog: FC<DialogProps> = (props) => {
  const primaryButton = (
    <Button
      accent={props.primaryBtnAccent}
      dataTestId={props.primaryBtnDataTestId}
      disabled={props.primaryDisabled}
      loading={props.primaryBtnLoading}
      onClick={props.onPrimaryClick}
      size='sm'
      variant={props.primaryBtnVariant ?? 'secondary'}
      type='button'
    >
      {props.primaryBtnMsg}
    </Button>
  );

  const secondaryButton = (
    <Button
      accent={props.secondaryBtnAccent}
      dataTestId={props.secondaryBtnDataTestId}
      disabled={props.secondaryDisabled}
      onClick={props.onSecondaryClick ?? props.onClose}
      size='sm'
      variant={props.secondaryBtnVariant ?? 'secondary'}
      type='button'
    >
      {props.secondaryBtnMsg}
    </Button>
  );

  return (
    <DialogBase
      headerMsg={props.headerMsg}
      subHeaderMsg={props.subHeaderMsg}
      onClose={props.onClose}
      actionsRight={primaryButton}
      actionsLeft={props.secondaryBtnMsg ? secondaryButton : null}
      closable={props.closable}
      capToWindowHeight={props.capToWindowHeight}
    >
      {props.children}
    </DialogBase>
  );
};
